module.exports = "/assets/data/95effcbbb88355f666818d0388e84e5d-OX33.data.json";